import { MenuItem } from '@mui/material';

import { Menu } from '@mui/material';

import { IconButton, useTheme } from '@mui/material';
import TranslateIcon from '../assets/icons/translate.svg';
import { MouseEvent, useState } from 'react';
import { branding } from '../branding';
import { activateLocale, locales } from '../utils/activateLocale';
import { useLocalStorage } from '@enroller/utils';

export const TranslateButton = () => {
  const theme = useTheme();
  const { defaultLocale } = branding;
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const [currentLocale, setCurrentLocale] = useLocalStorage<keyof typeof locales>('currentLocale', defaultLocale);

  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const setLocale = (locale: keyof typeof locales) => {
    activateLocale(locale);
    setCurrentLocale(locale);
    handleClose();
  };

  return (
    <>
      <IconButton
        id="language-menu-button"
        aria-controls={open ? 'language-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
        sx={{ borderRadius: '6px', border: `1px solid ${theme.palette.grey[200]}` }}
      >
        <img
          src={TranslateIcon}
          alt="Language"
          width={24}
          height={24}
          style={{
            filter: 'brightness(0)',
            opacity: 0.87,
          }}
        />
      </IconButton>
      <Menu
        id="language-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        sx={{ zIndex: 1302 }}
        MenuListProps={{
          'aria-labelledby': 'language-menu-button',
        }}
      >
        <MenuItem selected={currentLocale === 'en'} onClick={() => setLocale('en')} sx={{ '&.Mui-selected': { background: theme.palette.info.light } }}>
          EN
        </MenuItem>
        <MenuItem selected={currentLocale === 'es'} onClick={() => setLocale('es')} sx={{ '&.Mui-selected': { background: theme.palette.info.light } }}>
          ES
        </MenuItem>
        <MenuItem selected={currentLocale === 'fr'} onClick={() => setLocale('fr')} sx={{ '&.Mui-selected': { background: theme.palette.info.light } }}>
          FR
        </MenuItem>
      </Menu>
    </>
  );
};
